import { BRAND } from '@palaccount/config';
import { Landmark } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * The brand lockup: a blue rounded tile holding a bank-building icon, then the
 * product name (spec §4.1.4 / §4.3.1 — `account_balance` in the prototype's
 * Material set; Landmark is the lucide equivalent). The name itself comes from
 * the constant, never a literal (ruling R20).
 */
export function BrandMark({
  className,
  tileClassName,
  onPrimary = false,
}: {
  className?: string;
  tileClassName?: string;
  /** True when drawn on the blue panel, where the tile inverts. */
  onPrimary?: boolean;
}) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <span
        aria-hidden
        className={cn(
          'flex size-[34px] shrink-0 items-center justify-center rounded-lg',
          onPrimary ? 'bg-primary-foreground/15 text-primary-foreground' : 'bg-primary text-primary-foreground',
          tileClassName,
        )}
      >
        <Landmark className="size-5" />
      </span>
      <span className="text-lg font-bold leading-none">{BRAND.name}</span>
    </span>
  );
}
